<template>
  <div class="category-edit pr-md-24 mt-5">
    <div class="d-flex justify-end mb-2">
      <v-btn
        tile
        color="primary"
        @click="$router.push({ name: 'category-index' })"
      >
        <v-icon left>
          arrow_back
        </v-icon>
        Back
      </v-btn>
    </div>
    <v-card elevation="0" outlined class="pr-md-24 pl-md-4 mb-10 pt-4">
      <v-form
        v-model="valid"
        ref="form"
        lazy-validation
        @submit.prevent="updateCategory"
        v-if="category"
      >
        <v-container>
          <v-row class="mb-2">
            <v-col cols="12">
              <div class="text-left">
                <h4 class="back--text gotham-book">General Information</h4>
              </div>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" md="6" class="text-center">
                  <v-text-field
                    :counter="35"
                    label="Name"
                    v-model="category.name"
                    outlined
                    :rules="nameRules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-textarea
                    :counter="200"
                    label="Description"
                    outlined
                    :rules="descriptionRules"
                    v-model="category.description"
                    required
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-col>
            <!-- <v-btn type="submit" class="mx-0 mt-4">Update</v-btn> -->
            <v-col class="text-left">
              <v-btn color="accent">Update</v-btn>
            </v-col>
            <v-col cols="12">
              <hr />
            </v-col>
            <v-col cols="12">
              <div class="text-left">
                <h4 class="back--text gotham-book">Sub categories</h4>
              </div>
            </v-col>
            <v-col>
              <div
                class="d-flex justify-space-between align-center search-field-container"
              >
                <div class="flex pr-16">
                  <v-text-field
                    @keypress.enter="searchSubcategories"
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    class="p-1"
                    rounded
                    solo
                    outlined
                    label="Search Subcategories"
                    v-model="subcategory"
                  ></v-text-field>
                </div>
                <div>Browse All</div>
              </div>
            </v-col>
            <v-col cols="12" class="search-field-container">
              <div
                class="d-flex justify-space-between mb-2"
                v-for="subcategory in subcategories"
                :key="subcategory.id"
              >
                <div>
                  {{ subcategory.name }}
                </div>
                <div>
                  <v-btn icon outlined tile>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-col cols="12" class="search-field-container">
              <div class="d-flex justify-space-between mb-2">
                <v-pagination
                  color="#23A0A0"
                  v-model="subcategoryPage"
                  :length="parseInt(total / totalVisible, 10) + 1"
                  next-icon="mdi-chevron-right"
                  prev-icon="mdi-chevron-left"
                  :page="subcategoryPage"
                  :total-visible="totalVisible"
                ></v-pagination>
                <div>
                  <p class="total-visible">{{ totalVisible }}P/ Pages</p>
                </div>
              </div>
            </v-col>
            <v-col cols="12">
              <hr />
            </v-col>
            <v-col cols="12">
              <div class="text-left">
                <h4 class="back--text gotham-book">Products</h4>
              </div>
            </v-col>
            <v-col>
              <div
                class="d-flex justify-space-between align-center search-field-container"
              >
                <div class="flex pr-16">
                  <v-text-field
                    @keypress.enter="searchProducts"
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    class="p-1"
                    rounded
                    solo
                    outlined
                    label="Search Products"
                    v-model="product"
                  ></v-text-field>
                </div>
                <div>Browse All</div>
              </div>
            </v-col>
            <v-col cols="12">
              <div
                class="d-flex justify-space-between mb-2"
                v-for="product in products"
                :key="product.id"
              >
                <div>
                  {{ product.name }}
                </div>
                <div>
                  <v-btn icon outlined tile>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-col cols="12">
              <div class="d-flex justify-space-between mb-2">
                <v-pagination
                  color="#23A0A0"
                  v-model="productPage"
                  :length="
                    parseInt(totalProducts / totalVisibleProducts, 10) + 1
                  "
                  next-icon="mdi-chevron-right"
                  prev-icon="mdi-chevron-left"
                  :page="productPage"
                  :total-visible="totalVisibleProducts"
                ></v-pagination>
                <div>
                  <p class="total-visible">
                    {{ totalVisibleProducts }}P/ Pages
                  </p>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
    <!-- <v-row>
      <v-col sm="12" md="6">
        <SubcategoryList
          module="categories/LOAD_SUBCATEGORIES"
          :actions="false"
          :payload="{ from: 0, to: 10, categoryId: id }"
        />
      </v-col>
      <v-col sm="12" md="6">
        <ProductList
          module="categories/LOAD_PRODUCTS"
          :actions="false"
          :showFilters="false"
          :payload="{ from: 0, to: 10, categoryId: id }"
        />
      </v-col>
    </v-row> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
import SubcategoryList from "@/components/subcategory_management/SubcategoryList.vue";
import ProductList from "@/components/product_management/ProductList.vue";
export default {
  props: ["id"],
  components: {
    SubcategoryList,
    ProductList
  },
  data() {
    return {
      valid: false,
      subcategoryPage: 1,
      productPage: 1,
      totalVisible: 5,
      totalVisibleProducts: 5,
      product: null,
      subcategory: null,
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length >= 3) || "Name must be at least 3 characters",
        v =>
          (v && v.length <= 35) || "Name must be less than than 35 characters"
      ],
      descriptionRules: [
        v => !!v || "Description is required",
        v =>
          (v && v.length >= 3) || "Description must be at least 3 characters",
        v =>
          (v && v.length <= 200) ||
          "Description must be less than than 200 characters"
      ]
    };
  },
  mounted() {
    this.$store.dispatch("categories/LOAD_CATEGORY", {
      categoryId: this.id
    });
    this.getProducts({ categoryId: this.id, from: 0, to: 5 });
    this.getSubcategories({
      from: 0,
      to: 5,
      categoryId: this.id
    });
  },
  watch: {
    subcategoryPage(val) {
      let pagination = {
        itemsPerPage: this.totalVisible,
        page: val
      };
      this.updateSubcategoryPagination(pagination);
    },
    productPage(val) {
      let pagination = {
        itemsPerPage: this.totalVisible,
        page: val
      };
      this.updateProductPagination(pagination);
    }
  },
  computed: {
    ...mapState({
      countries: state => state.countries.countries,
      category: state => state.categories.category,
      subcategories: state => state.subcategories.subcategories,
      products: state => state.products.products,
      totalProducts: state => state.products.totalProducts,
      total: state => state.subcategories.totalSubcategories
    })
  },
  methods: {
    searchProducts() {
      let payload = {
        categoryId: this.id,
        from: 0,
        to: 5,
        productName: this.product
      };
      this.getProducts(payload);
    },
    searchSubcategories() {
      let payload = {
        categoryId: this.id,
        from: 0,
        to: 5,
        name: this.subcategory
      };
      this.getSubcategories(payload);
    },
    updateProductPagination(pagination) {
      let payload = { categoryId: this.id };
      (payload.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage),
        (payload.to =
          pagination.itemsPerPage === -1
            ? this.totalItems
            : pagination.itemsPerPage);
      this.getProducts(payload);
    },
    updateSubcategoryPagination(pagination) {
      let payload = { categoryId: this.id };
      (payload.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage),
        (payload.to =
          pagination.itemsPerPage === -1
            ? this.totalItems
            : pagination.itemsPerPage);
      this.getSubcategories(payload);
    },
    async getSubcategories(payload) {
      await this.$store.dispatch("subcategories/LOAD_SUBCATEGORIES", payload);
    },
    async getProducts(payload) {
      await this.$store.dispatch("categories/LOAD_PRODUCTS", payload);
    },
    async updateCategory() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Updating category...",
          html: "this will only take a moment...",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("categories/UPDATE_CATEGORY", this.category);
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "Category has been updated",
          icon: "info"
        });
      }
    }
  }
};
</script>
<style>
.theme--light.v-pagination .v-pagination__item--active {
  color: #000;
  font-weight: bold;
  background-color: initial !important;
  border-color: initial !important;
}
.v-pagination__item {
  box-shadow: initial !important;
}
.v-pagination__navigation {
  box-shadow: initial !important;
  font-weight: bold;
}
.total-visible {
  color: #23a0a0;
  text-decoration: underline;
  cursor: pointer;
}
.category-edit .search-field-container .v-input__slot {
  min-height: initial !important;
  box-shadow: initial !important;
}
.category-edit .search-field-container .v-input__control {
  min-height: initial !important;
}
.category-edit .search-field-container .v-pagination__item--active {
  color: #000 !important;
  font-weight: bold;
}
</style>
